var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnoccupiedBed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Level Icon/Active/Bed/Unoccupied Bed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Level-Icon/Active/Bed/Unoccupied-Bed",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5,5.5 L3.5,7.50000047 L16.9965027,7.49998777 C18.3792482,7.50965967 19.6160718,7.96785169 20.7080914,8.87410869 C21.7631317,9.74967689 22.3257006,11.3736152 22.480631,13.6899446 L22.5,14.0255528 L22.5,19.5 L20.5,19.5 L20.5,16.5 L3.5,16.5 L3.5,19.5 L1.5,19.5 L1.5,5.5 L3.5,5.5 Z M17.0270508,9.49579234 L8.49785921,9.49944046 L8.49785921,14.5117755 L18.9934758,14.5134317 L20.4761862,14.5134316 L20.4939924,14.1955893 C20.5642335,12.532676 20.2408601,11.3846911 19.6193222,10.7036368 C19.001604,10.0267681 18.1423699,9.61464376 17.0270508,9.49579234 L17.0270508,9.49579234 Z M7.51106337,9.49992901 L3.5,9.50790434 L3.5,14.5118544 L7.51106337,14.5118544 L7.51106337,9.49992901 Z",
    id: "Combined-Shape",
    stroke: "#579800",
    fill: "#579800"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnoccupiedBed);
export default __webpack_public_path__ + "static/media/UnoccupiedBed.e5002b5c.svg";
export { ForwardRef as ReactComponent };